// extracted by mini-css-extract-plugin
module.exports = {"add":"AddJob_add__2BNQA"};